import { useSnackbar } from 'notistack';
import axios, { AxiosError } from 'axios';

interface ErrorResponseData {
    message: string;
}

export default function useErrorHandler() {
    const { enqueueSnackbar } = useSnackbar();

    return (error: unknown) => {
        console.log(error);

        if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError;
            if (axiosError.response) {
                const responseData = axiosError.response.data as ErrorResponseData;
                enqueueSnackbar(responseData.message, { variant: 'error' });
                return;
            } else if (axiosError.message === 'Network Error') {
                enqueueSnackbar('Ошибка сети', { variant: 'error' });
                return;
            }
        }

        if (error instanceof Error) {
            enqueueSnackbar(error.message, { variant: 'error' });
        } else {
            enqueueSnackbar('Неизвестная ошибка', { variant: 'error' });
        }
    };
}
